import Swal, { SweetAlertIcon } from "sweetalert2";

export class ToastService {
  public title!: string;
  public icon!: SweetAlertIcon;
  public toast: typeof Swal;

  constructor() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
        toast.addEventListener("click", () => Swal.close());
      },
    });
  }

  showAlert() {
    this.toast.fire({
      icon: this.icon,
      title: this.title,
    });
  }

  static success(msg: string) {
    const vm = new ToastService();
    vm.icon = "success";
    vm.title = msg;
    vm.showAlert();
  }

  static error(msg: string) {
    const vm = new ToastService();
    vm.icon = "error";
    vm.title = msg;
    vm.showAlert();
  }

  static warning(msg: string) {
    const vm = new ToastService();
    vm.icon = "warning";
    vm.title = msg;
    vm.showAlert();
  }

  static info(msg: string) {
    const vm = new ToastService();
    vm.icon = "info";
    vm.title = msg;
    vm.showAlert();
  }

  static question(msg: string) {
    const vm = new ToastService();
    vm.icon = "question";
    vm.title = msg;
    vm.showAlert();
  }
}

export class Alert {
  static confirm(title = "", desc = "") {
    return new Promise((resolve) => {
      Swal.fire({
        title: title,
        html: desc,
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonColor: "#333333",
        confirmButtonColor: "#ff0000",
        icon: "question",
      }).then((result) => {
        if (result.isConfirmed) {
          return resolve(true);
        }
        return resolve(false);
      });
    });
  }
  static success(title = "", desc = "") {
    // return Swal.fire(title,desc,"success")
    return new Promise((resolve) => {
      Swal.fire({
        title: title,
        text: desc,
        showCancelButton: false,
        confirmButtonText: "Yes",
        confirmButtonColor: "#03A415",
        icon: "success",
      }).then((result) => {
        if (result.isConfirmed) {
          return resolve(true);
        }
        return resolve(false);
      });
    });
  }

  static error(title = "", desc = "") {
    return Swal.fire(title, desc, "error");
  }

  static warning(title = "", desc = "") {
    return Swal.fire(title, desc, "warning");
  }

  static question(title = "", desc = "") {
    return Swal.fire(title, desc, "error");
  }
}
